export const FORMATS = {
  monthDay: 'MM-dd',
  dayMonthYear: 'dd-MM-yyyy',
  dayMonthYearSlash: 'dd/MM/yyyy',
  monthDayYear: 'MM/dd/yyyy',
  hours: 'hh:mm a',
};
